module.exports = __webpack_public_path__ + "img/07.72996c0c.jpg";